export enum ClientCabinetType {
  SberBank = 'sb',
  BankRossii = 'abr',
  AlfaBank = 'af',
  TBank = 'tb',
  VTB = 'vtb',
  RaiffeisenBank = 'rf',
  CentralBank = 'cbr',
}
